import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PaymentMethodDialog = ({ open, onClose, onSelect }) => {
  const handleSelection = (method) => {
    onSelect(method);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        เลือกวิธีการชำระเงิน
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="h6" color="textSecondary" sx={{ mb: 2 }}>
          หลังจากเลือกช่องทางการชำระเงินแล้ว จะแสดงหน้าปริ้นใบเสร็จ
        </Typography>
        {/* ปุ่มเรียงแนวนอน ชิดกัน */}
        <Box display="flex" gap={1}>
          <Button
            fullWidth
            onClick={() => handleSelection('เงินสด')}
            color="success"
            variant="contained"
            sx={{ height: 60 }}
          >
            เงินสด
          </Button>
          <Button
            fullWidth
            onClick={() => handleSelection('โอนเงิน')}
            color="info"
            variant="contained"
            sx={{ height: 60 }}
          >
            โอนเงิน
          </Button>
          {/* <Button
            fullWidth
            onClick={() => handleSelection('ATM')}
            color="warning"
            variant="contained"
            sx={{ height: 60 }}
          >
            ATM
          </Button> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodDialog;
